export const hasTwoFactorAuthentication = (to, from, next) => {
    if (to.path == "/enable-two-factor-auth" && window.user?.twoFactorEnabled) {
        return next({ name: "sale-atendimento" });
    }

    if (to.path == "/enable-two-factor-auth") {
        return next();
    }

    if (!window.user?.twoFactorEnabled) {
        return next({ name: "enable-two-factor-auth" });
    }

    return next();
};
